import React from "react";
import {
  PanelCard,
  StickyFooterPanelCard,
} from "@sonder/ui/source/styled/fragments/PanelCard";
import { PanelContent } from "@sonder/ui/source/styled/layouts/PanelContent";
import { Divider } from "@sonder/ui/source/styled/primitives/Divider";
import { TaskData } from "core/queries/GetTask";
import { ReportIssueButton } from "tasks/components/TaskPanel/ReportIssueButton";
import { MetadataCard } from "tasks/components/TaskPanel/Unit/MetadataCard";
import { TurnoverCard } from "tasks/components/TaskPanel/Unit/TurnoverCard";
import { UnitCompletedTasks } from "tasks/components/TaskPanel/Unit/UnitCompletedTasks";
import { UnitInfoCard } from "tasks/components/TaskPanel/Unit/UnitInfoCard";
import { UnitOpenTasks } from "tasks/components/TaskPanel/Unit/UnitOpenTasks";
import { isCleanTask, parseGraphQLId } from "tasks/helpers";
import { TaskContextSubjectTypeEnum, TypeEnum } from "typings/globalGQLTypes";

interface UnitProps {
  task: TaskData;
}
export const Unit = ({ task }: UnitProps) => {
  const { id: taskId, city, unit } = task;
  if (!unit)
    return (
      <PanelContent>
        <PanelCard>There is no unit associated with this task.</PanelCard>
      </PanelContent>
    );

  const { bookingInfo, id: unitId } = unit;
  const cityId = city?.id;
  return (
    <PanelContent>
      <UnitInfoCard taskId={taskId} unit={unit} />
      {isCleanTask(task.type) && <MetadataCard task={task} />}
      <Divider />
      {bookingInfo && <TurnoverCard bookingInfo={bookingInfo} />}
      <UnitOpenTasks cityId={cityId} taskId={taskId} unitId={unitId} />
      <UnitCompletedTasks cityId={cityId} taskId={taskId} unitId={unitId} />
      <StickyFooterPanelCard>
        <div>
          <ReportIssueButton
            subjectId={parseGraphQLId(unitId)}
            subjectType={TaskContextSubjectTypeEnum.Unit}
            taskType={TypeEnum.Tom_Tasks_Issue}
          />
        </div>
      </StickyFooterPanelCard>
    </PanelContent>
  );
};
